import { IconChevronUp24 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './ToTopButton.css';

interface IToTopButtonProps {
  onClick: VoidFunction;
}

export const ToTopButton: FC<IToTopButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['to-top-button']} onClick={onClick}>
      <IconChevronUp24 color="primary_100" />
    </button>
  );
};
